'use client';

import { ReactNode, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { ErrorBoundary } from '@datadog/browser-rum-react';
import ClientClerkWrapper from './ClientClerkWrapper';
import { initDatadogRum } from '@/lib/analytics/datadogRum';
import { initDatadogLogs } from '@/lib/analytics/datadogLogger';

type RouteAwareAppWrapperProps = {
  children: ReactNode;
};

const EmptyFallback = () => null;

export function RouteAwareAppWrapper({ children }: RouteAwareAppWrapperProps) {
  const pathname = usePathname();
  const bypassClientClerkWrapper = pathname?.startsWith('/tv') || pathname?.startsWith('/remote');

  useEffect(() => {
    if (bypassClientClerkWrapper) {
      initDatadogRum();
      initDatadogLogs();
    }
  }, [bypassClientClerkWrapper]);

  if (bypassClientClerkWrapper) {
    return <ErrorBoundary fallback={EmptyFallback}>{children}</ErrorBoundary>;
  }

  return <ClientClerkWrapper>{children}</ClientClerkWrapper>;
}
